import Constants from '@/Constants';
import { ChangePasswordData } from '@/models/LoginData';
import { ApplicationState } from '@/store';
import { changePasswordClear, changePasswordRequest } from '@/store/identity/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';

interface ChangePasswordProps {
    userId: number;
}

const ChangePassword = ({ userId }: ChangePasswordProps) => {
    const [newPassword, setNewPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [visibilityPasswordType, setVisibilityPasswordType] = useState('password');
    const [visibilityPasswordIcon, setVisibilityPasswordIcon] = useState(Constants.icons.VISIBILITY_OFF);
    const [showMessage, setShowMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);

    const { data: strings } = useSelector((state: ApplicationState) => state.locale);
    const { data: identity, success, hasError } = useSelector((state: ApplicationState) => state.identity);
    const dispatch = useDispatch();

    useEffect(() => {
        if (success) {
            setShowMessage(true);
            setNewPassword('');
            setRepeatPassword('');

            setTimeout(() => dispatch(changePasswordClear()), 3000);
        } else {
            setShowMessage(false);
        }
    }, [dispatch, success]);

    useEffect(() => {
        if (hasError) {
            setShowErrorMessage(true);
        } else {
            setShowErrorMessage(false);
        }
    }, [hasError]);

    useEffect(() => {
        dispatch(changePasswordClear());
    }, [dispatch]);

    const handleVisibityChange = (event: any): void => {
        event.preventDefault();
        const icons: string[] = [Constants.icons.VISIBILITY_OFF, Constants.icons.VISIBILITY];
        const types: string[] = ['password', 'text'];

        setVisibilityPasswordType(types[+(visibilityPasswordType === types[0])]);
        setVisibilityPasswordIcon(icons[+(visibilityPasswordIcon === icons[0])]);
    };

    const handleSubmit = () => {
        const payload: ChangePasswordData = {
            applicationId: identity.person.applicationId,
            newPassword,
            userId,
        };

        dispatch(changePasswordRequest(payload));
    };

    return (
        <>
            <div className="row input-section">
                <div className="title-container">
                    <h1>{strings.NEW_PASS}</h1>
                </div>
                <input
                    className="form-control"
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder={strings.NEW_PASS}
                    required
                    type={visibilityPasswordType}
                    value={newPassword || ''}
                />
            </div>
            <div className="row input-section">
                <div className="title-container">
                    <h1>{strings.REPEAT_PASS}</h1>
                </div>
                <div className="inner-addon right-addon">
                    <button className="btn btn-link" onClick={handleVisibityChange} type="button">
                        <i className="material-icons">{visibilityPasswordIcon}</i>
                    </button>
                    <input
                        className="form-control"
                        onChange={(e) => setRepeatPassword(e.target.value)}
                        placeholder={strings.REPEAT_PASS}
                        type={visibilityPasswordType}
                        value={repeatPassword}
                    />
                </div>
            </div>
            <div className={`message ${showMessage ? 'success' : ''} ${showErrorMessage ? 'error' : ''}`}>
                <i className="material-icons align-middle">
                    {`${showMessage ? 'check_circle' : ''}`}
                    {`${showErrorMessage ? 'error' : ''}`}
                </i>
                <span>
                    {`${showMessage ? strings.CHANGE_PASS_SUCCESS : ''}`}
                    {`${showErrorMessage ? strings.CHANGE_PASS_FAILURE : ''}`}
                </span>
            </div>
            <div className="modal-confirm-button">
                <button
                    className="btn btn-secondary confirm-button"
                    disabled={newPassword.length === 0 || newPassword !== repeatPassword}
                    onClick={handleSubmit}
                    type="button"
                >
                    {strings.CONFIRM_CHANGES}
                </button>
            </div>
        </>
    );
};

export default ChangePassword;
